/**
 * Algolia Insights requires queryID to be the search `queryID` returned by the Search API
 * when click analytics is enabled — a 32-character hexadecimal string.
 */
const ALGOLIA_SEARCH_QUERY_ID_RE = /^[a-f0-9]{32}$/i;

export function isAlgoliaSearchQueryId(value: string): boolean {
  return typeof value === "string" && ALGOLIA_SEARCH_QUERY_ID_RE.test(value.trim());
}
